module.exports = __webpack_public_path__ + "img/pensamento-sistemico-1.40127ddd.jpg";